import './collageQuote.scss';

import classNames from 'classnames';
import Image from 'gatsby-plugin-sanity-image';
import React from 'react';

import { BarebonesPortableText } from '../barebones-portable-text';

export function CollageQuote({
	aspectRatio,
	backgroundColor,
	backgroundImage,
	cardHeight,
	cardStyle,
	quote,
	source,
	textColor,
}) {
	return (
		<div
			className={classNames('quote-card', backgroundColor)}
			style={{
				...cardHeight,
				borderRadius: `${cardStyle}`,
				aspectRatio: `${aspectRatio}`,
			}}
		>
			{backgroundImage?.asset && (
				<div className={classNames('bg-image')}>
					<Image
						alt={backgroundImage.alt || ''}
						className='quote-card-img'
						loading='lazy'
						{...backgroundImage}
					/>
				</div>
			)}
			{quote && (
				<figure>
					<blockquote>
						<BarebonesPortableText
							className={textColor}
							blocks={quote}
						/>
					</blockquote>
					<figcaption
						className={classNames(textColor, 'body-sm-caps')}
						style={{
							opacity: '.6',
							fontSize: 'clamp(9px, 5cqw, 14px)',
						}}
					>
						— {source}
					</figcaption>
				</figure>
			)}
		</div>
	);
}
